import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UserServiceService } from "../user-service.service";
import { ToastService } from "../toast.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LazyImgDirective } from "../lazy-img.directive";
import { FormsModule } from "@angular/forms";
import { MatFormField , MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatCard } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-reset-password-new",
  templateUrl: "./reset-password-new.component.html",
  styleUrls: ["./reset-password-new.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LazyImgDirective,
    FormsModule,
    MatFormField, MatLabel, MatSuffix,
    MatInput,
    MatIconButton, MatButton,
    MatCard,
    MatIcon
  ]
})
export class ResetPasswordNewComponent implements OnInit {
  model: any = {};
  model2: any = {};
  id: any;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(
    private userService: UserServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(param => {
      this.id = param["id"];
    });
  }

  register() {
    if (this.model.password != this.model.cpassword) {
      this.toast.error("Passwords do not match");
    } else {
      this.model2.password = this.model.password;
      this.model2.id = this.id;

      this.userService.resetPassword(this.model2).subscribe(data => {
        if (data["success"]) {
          this.toast.success("Password reset successfully");
          this.router.navigate(["/login-page"]);
        } else {
          this.toast.error(data["message"] || "Could not reset password");
        }
      });
    }
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }
}
